import { Injectable } from "@angular/core";
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpResponse,
  HttpErrorResponse,
} from "@angular/common/http";
import { LoginService } from "@app/modules/auth/login/services/login.service";
import { ToastrMessageService } from "@app/shared/services/toastr-message/toastr-message.service";
import { Observable, of } from "rxjs";
import { tap, catchError } from "rxjs/operators";

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  constructor(
    private loginService: LoginService,
    private toastrMessageService: ToastrMessageService
  ) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // We should not add access_token to login, register & refreshToken API's
    const urlToIgnore = /login/gi || /register/gi;

    if (request.url.search(urlToIgnore) === -1) {
      request = request.clone({
        setParams: {
          access_token: this.loginService.getTokenFromCookie(),
        },
      });
    }

    return next.handle(request).pipe(
      tap((evt) => {
        if (evt instanceof HttpResponse) {
          // console.log(evt);
        }
      }),
      catchError((err: any) => {
        if (err instanceof HttpErrorResponse) {
          // console.log(err);
          if (err.status == 0) {
          }
        }
        return of(err);
      })
    );
  }
}
